var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-dialog', {
    attrs: {
      "width": "500",
      "overlay-color": "rgba(39, 50, 64)",
      "overlay-opacity": "0.6",
      "fullscreen": _vm.$vuetify.breakpoint.xs ? true : false
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('process', {
    ref: "process",
    attrs: {
      "invoice-id": _vm.invoiceId
    }
  }), _c('v-card', [_c('v-card-title', {
    staticClass: "header"
  }, [_vm._v(" " + _vm._s(_vm.$t('globals.depositButton')) + " ")]), _c('v-card-text', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "mt-6 mb-8"
  }, [_vm._v(" " + _vm._s(_vm.$t('globals.depositDesc')) + " ")]), _c('v-text-field', {
    staticClass: "mt-3",
    attrs: {
      "name": "amount",
      "maxlength": "12",
      "label": _vm.$t('withdrawals.amount'),
      "error-messages": _vm.AmountErrors
    },
    on: {
      "input": function input($event) {
        return _vm.$v.amount.$touch();
      },
      "blur": function blur($event) {
        return _vm.$v.amount.$touch();
      },
      "keypress": function keypress($event) {
        return _vm.onlyForCurrency($event, _vm.amount);
      }
    },
    scopedSlots: _vm._u([{
      key: "append",
      fn: function fn() {
        return [_c('small', {
          staticClass: "text-no-wrap text-right"
        }, [_vm._v(" " + _vm._s(_vm.$t('globals.reqMax')) + ": "), _c('b', {
          class: 'text-positive',
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function click($event) {
              _vm.amount = 2500;
            }
          }
        }, [_vm._v("2500 USDT")]), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t('withdrawals.reqMin')) + ": 10 USDT")])])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.amount,
      callback: function callback($$v) {
        _vm.amount = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "amount"
    }
  })], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.activate
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('globals.depositButton')) + " ")])], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }